export const LOAD_DATENSTAND = "loadDatenstand"
